
export default {
  name: 'FaqNavigation',
  props: {
    // No props needed as it's now self-contained
  },
  data() {
    return {
      openSubmenus: {}, // State managed internally
      // Hardcoded menu structure
      menuData: [
        {
            mainCluster: "General TEFL / TESOL Questions",
            id: "general-tefl-tesol-questions",
            subClusters: [{ name: null, id: "general-tefl-tesol-questions" }] // ID added for consistency, name null means no sub-heading in menu
        },
        {
            mainCluster: "Certificates and Accreditation",
            id: "tefl-org-certificates-accreditation",
            subClusters: [{ name: null, id: "tefl-org-certificates-accreditation" }]
        },
        {
            mainCluster: "TEFL Courses",
            id: "tefl-courses-main",
            subClusters: [
                { name: "Choosing & Entry Requirements", id: "choosing-entry-requirements" },
                { name: "Pricing & Payments", id: "pricing-payments" },
                { name: "Tutor Support & Learning Experience", id: "tutor-support-learning-experience" },
                { name: "Online TEFL Courses", id: "online-tefl-courses-sub" },
                { name: "Combined TEFL Courses (Online + Classroom)", id: "combined-tefl-courses-sub" },
                { name: "Level 5 TEFL Diploma", id: "level-5-tefl-diploma-sub" },
                { name: "Advanced TEFL Courses", id: "advanced-tefl-courses-sub" },
                { name: "Classroom TEFL Courses (In-Person and Zoom Classes)", id: "classroom-tefl-courses-sub" }
            ]
        },
        {
            mainCluster: "Audio Course",
            id: "audio-course-main",
            subClusters: [
              { name: "Course Overview", id: "audio-course-overview-sub" },
              { name: "Learning Experience", id: "audio-course-learning-sub" },
              { name: "Devices & Access", id: "audio-course-devices-sub" },
              { name: "Assessments & Certification", id: "audio-course-assessments-sub" },
              { name: "Support & Technical Help", id: "audio-course-support-sub" }
            ]
        },
        {
            mainCluster: "TEFL Jobs",
            id: "tefl-jobs-main",
            subClusters: [
                { name: "Teaching English Abroad", id: "teaching-english-abroad-sub" },
                { name: "Teaching English Online", id: "teaching-english-online-sub" },
                { name: "Teach English Locally", id: "teach-english-locally-sub" }
            ]
        }
      ]
    };
  },
  mounted() {
    // Initialize openSubmenus based on the menu structure
    this.menuData.forEach(mainCluster => {
      if (mainCluster.subClusters.length > 1 || mainCluster.subClusters[0].name !== null) {
        this.$set(this.openSubmenus, mainCluster.id, false); // All closed by default
      }
    });
  },
  methods: {
    toggleSubmenu(mainClusterId) {
      this.$set(this.openSubmenus, mainClusterId, !this.openSubmenus[mainClusterId]);
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    handleMainMenuClick(mainClusterId) {
      const mainCluster = this.menuData.find(cluster => cluster.id === mainClusterId);
      if (mainCluster && (mainCluster.subClusters.length > 1 || mainCluster.subClusters[0].name !== null)) {
        this.toggleSubmenu(mainClusterId);
      }
      this.scrollToSection(mainClusterId);
    }
  }
};
